<template>
    <div class="d-flex direct-login" style="height: 100%;">
      <div class="w-50">
        <v-container class="popup-container main-container">
          <v-row class="popup-container row-container">
            <div class="center-h pt-0">
              <v-content>
                <v-card fill-height class="improve-login-card">
                  <v-img
                    class="center-v login-logo hover-cursor"
                    src="static/brand/logo.png"
                    alt="IMPROVE"
                    contain
                    @click="openInNewTab()"
                  ></v-img>
                  <v-card-text class="center-v partner-login-form">
                    <p class="partner-login-label center-v">Log in</p>
                    <br />
                    <div style="font-size: 16px;">
                      Need an IMPROVE account?
                      <router-link to="/signup">Create an account</router-link>
                    </div>
                    <v-spacer></v-spacer>
                    <v-alert
                      class="mt-8 text-center"
                      v-if="errMsg"
                      :value="alert"
                      color="#ffcbcb"
                      ><b> Login failed </b>
                      <p>{{ errDetail }}</p>
                    </v-alert>
                    <div class="mt-8 parnter-login">
                      <span
                        >Are you a Partner?
                        <a :href="$globalConfig.PARTNER_URL"
                          >Log in here</a
                        ></span
                      >
                    </div>
                    <div class="label mt-4">Email:</div>
                    <v-text-field
                      v-model="email"
                      type="text"
                      placeholder="johnsmith@email.com"
                      outlined
                      required
                      class="input"
                      @keyup.enter="login"
                    ></v-text-field>
                    <div class="label mt-7">Password:</div>
                    <v-text-field
                      v-model="password"
                      placeholder="*******"
                      outlined
                      required
                      class="input"
                      :append-icon="showInput ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="showInput ? 'text' : 'password'"
                      @click:append="toggleInputVisibility"
                      @keyup.enter="login"
                    ></v-text-field>
                    <v-spacer></v-spacer>
                  </v-card-text>
                  <v-card-text class="forgot_password mr-auto ml-auto">
                    <span>
                      By logging into Improve you agree to our <br />
                      <a
                        @click.prevent="toggleCheckboxState(privacyPolicyLink)"
                        href="#"
                        >Privacy Policy</a
                      >
                      and
                      <a
                        @click.prevent="toggleCheckboxState(termsConditionsLink)"
                        href="#"
                        >Terms and Conditions</a
                      >
                    </span>
                    <span class="d-block mt-2"><cookie-settings-link></cookie-settings-link></span>
                  </v-card-text>
                  <v-card-actions class="center-v login-btn">
                    <v-btn v-if="loading" color="primary" loading></v-btn>
                    <v-btn
                      v-else
                      color="primary"
                      class="login-button"
                      @click.prevent="login"
                      >Login</v-btn
                    >
                  </v-card-actions>
                  <v-card-text class="center-v forgot_password">
                    <router-link class="" to="/forgot-password"
                      >Forgot Password</router-link
                    >
                  </v-card-text>
  
                  <v-flex class="mt-4 pa-4 center-v">
                      <v-card-text class="login-frm">
                        <v-btn @click="loginWithSSO('Microsoft')" class="sso-btn input" x-large>
                          <div class="icon">
                          <img src="/static/microsoft-logo.svg" alt="#" class="mr-5">
                          </div>
                          <img src="/static/sso-vertical-seperator.png" alt="#" class="mr-3">
                          <span class="login-text">Login with Microsoft</span>
                        </v-btn>
                        <v-btn @click="loginWithSSO('Google')" class="sso-btn input google-btn" x-large>
                          <div class="icon">
                          <img src="/static/google-logo.svg" alt="#" class="mr-5">
                          </div>
                          <img src="/static/sso-vertical-seperator.png" alt="#" class="mr-3">
                          <span class="login-text">Login with Google</span>
                        </v-btn>
                      </v-card-text>
                    </v-flex>
                </v-card>
              </v-content>
            </div>
          </v-row>
        </v-container>
      </div>
      <div class="login-background-img"></div>
      <div>
        <img
          src="static/brand/login-illustration-mobile.png"
          class="login-center-img"
          align="center"
        />
      </div>
    </div>
  </template>
  
  <script>
  import { isTrialCompanyAdmin } from '@/utils/onboarding';
  import { resolveWizardLock } from '@/utils/wizardLock';
  import { canBookWebinar, openWebinarBooking } from '@/utils/webinarBooking';
  import CookieSettingsLink from '@/components/CookieSettingsLink';

  export default {
    name: 'DirectLogin',
    components: { CookieSettingsLink },
    data: () => ({
      password: '',
      email: '',
      valid: true,
      loading: false,
      messages: {
        email: [],
        password: [],
        error: [],
      },
      isChecked: false,
      privacyPolicyLink: 'https://www.improve.online/privacy-policy/',
      termsConditionsLink: 'https://www.improve.online/eula/ ',
      alert: true,
      errMsg: '',
      errDetail: 'Please check your sign in details and try again',
      showInput: false,
    }),
    created() {
      // From the signup confirmation page: the email they just registered.
      const q = this.$route && this.$route.query && this.$route.query.email;
      if (q && !this.email) this.email = String(q);
    },
    methods: {
      openInNewTab: function()
      {
         window.open(this.$globalConfig.FRONTEND_URL, '_blank');
      },
      login: function() {
        this.loading = true;
        this.$store
          .dispatch('login', {
            email: this.email,
            password: this.password,
          })
          .then((resp) => {
              this.getProfile();
          })
          .catch((err) => {
            this.loading = false;
            this.valid = false;
            this.messages = [];
            let errors = err.response.data.errors;
            // this.errMsg = err.response.data.message;
            // if (this.errMsg) {
            //   this.errMsg = errors != null && errors.email && errors.email[0].search("The selected email is invalid.") != 0 ? errMsg : "The email/password combination entered was incorrect. Please check your credentials and try again."
            //   this.errorMessage = this.errMsg;
            // }
            if (err.response.status == 401) {
              // The API sends one of two things on a 401: a credentials
              // rejection, or an account-state refusal ("This account has
              // been suspended, please refer to your admin user", which is
              // what every learner on an expired or suspended company gets).
              // Only the state message is worth showing verbatim; a learner
              // told to "check your sign in details" when their company's
              // trial has ended will reset their password for nothing.
              const apiMsg = (err.response.data && err.response.data.message) || "";
              this.errDetail = /suspended|expired/i.test(apiMsg)
                ? apiMsg
                : "Please check your sign in details and try again";
              this.errMsg =
                '<b> Login failed </b> <p> ' + this.errDetail + ' </p>';
            } else if (err.response.status == 500) {
              this.$snotify.error(err.response.data.message);
            }
            if (errors) {
              for (let field in errors) {
                this.messages[field] = errors[field];
              }
            }
          });
      },
      getProfile() {
        this.$store
          .dispatch('profile')
          .then((resp) => {
            // The trial and webinar emails' link (?next=improve-live): the
            // IMPROVE Live booking popup opens over wherever the admin lands.
            const next = this.$route && this.$route.query && this.$route.query.next;
            if (next === 'improve-live' && canBookWebinar(this.$store.getters)) {
              openWebinarBooking();
            }
            // Expired trial (state 2) admins land on the locked trial-ended page.
            if (Number(this.$store.getters.level) === 2 && Number(this.$store.getters.companyState) === 2) {
              this.$router.push('/trial-ended');
              return;
            }
            // A suspended company's admin (state 4; since 10 Oct 2026 also a
            // trial whose bank transfer invoice went unpaid) can only open the
            // finance pages: router.js sends everything else to /admin/finance.
            // Push there, not to a page the guard redirects, which vue-router
            // reports as an uncaught error.
            if (Number(this.$store.getters.level) === 2 && Number(this.$store.getters.companyState) === 4) {
              this.$router.push('/admin/finance');
              return;
            }
            switch (this.$store.getters.level) {
              case 1:
                this.$router.push('/super-admin/companies');
                break;
              case 2:
                // A trial admin who has not finished the Welcome to IMPROVE
                // wizard starts there, decided from the SERVER's progress
                // (wizardLock.js): this browser's cache alone sent admins who
                // had finished on another device back to the wizard. Push the
                // final page, not "/": vue-router reports a push its guard
                // redirects as an uncaught error.
                if (isTrialCompanyAdmin(this.$store.getters)) {
                  resolveWizardLock(this.$store.getters).then((locked) => {
                    this.$router.push(locked ? '/welcome' : '/admin/users');
                  });
                } else {
                  this.$router.push('/admin/users');
                }
                break;
              case 7:
                this.$router.push('/course-library');
                break;
              case 8:
                this.$router.push('/invoicing-admin/companies');
                break;
              default:
                this.$router.push('/courses');
                break;
            }
          })
          .catch((err) => {
            // Auth succeeded but loading the profile genuinely failed (network / 5xx).
            // Don't strand the user silently on the login screen — surface it so they can retry.
            this.loading = false;
            this.$snotify.error('You are signed in, but we could not load your account. Please try again, and contact support if this continues.');
          });
      },
      toggleCheckboxState(link) {
        window.open(link, '_blank'); // Open the link in a new tab
        // this.isChecked = !this.isChecked; // Toggle the checkbox state
      },
      toggleInputVisibility() {
        this.showInput = !this.showInput;
      },
      loginWithSSO(provider) {
        let url = this.$globalConfig.SSO_URL + '/' + provider.toLowerCase();
        window.open(url, "_self")
      },
    },
  };
  </script>
  <style>
  .v-alert {
    color: #4f0e0e !important;
  }
  
  .v-alert__content p {
    margin: 0 !important;
  }
  
  .hover-cursor {
      cursor: pointer; /* or any other type of cursor you prefer */
  }
  
  .sso-btn {
    padding-top: 27px !important;
    padding-bottom: 27px !important;
    width: 320px;
    height: 56px;
    display: flex;
    justify-content: flex-start;
    color: #333333;
    font-size: 18px;
    background: transparent !important;
    height: 56px;
    border: 1px solid #c4c4c4 !important;
    text-transform: none;
    letter-spacing: 0;
    margin: 0;
  }
  .sso-btn .icon{
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 25px;
    margin-right: 15px;
    max-width: 25px;
    min-width: 25px;
  }
  .sso-btn .icon img{
    width: 100%;
    height: 25px;
  }
  .login-text {
    flex: 1;
    text-align: left;
  }
  </style>
  <style>
  /* The new IMPROVE branding (Steve, 9 Oct 2026): the logo and the colours
     only, the website's navy and teal; words, layout and fonts unchanged.
     Everything here sits under .direct-login because the global rules it
     overrides (assets/custom.scss) also style the partner and Senso logins,
     and the theme's primary colour styles the whole app. The illustrations
     are the old ones with the old mint green recoloured to the teal. */
  .direct-login {
    --brand-navy: #002458;
    --brand-teal: #08a0a8;
    --brand-tint: #eef8f8;
  }
  .direct-login .improve-login-card .login-logo {
    /* !important: .center-v (custom.scss) sizes it to fit-content with
       !important, which for this 900px wide file is 900px and pushed the
       login card over the illustration. */
    width: 200px !important;
    height: 66px;
  }
  .direct-login .partner-login-label,
  .direct-login .label {
    color: var(--brand-navy);
  }
  .direct-login .partner-login-form a,
  .direct-login .forgot_password a {
    color: var(--brand-teal) !important;
  }
  .direct-login .parnter-login {
    border-color: var(--brand-teal);
    color: var(--brand-navy);
    background: var(--brand-tint);
  }
  .direct-login .login-btn .v-btn,
  .direct-login .login-button {
    background-color: var(--brand-teal) !important;
    color: #ffffff !important;
  }
  /* A focused field's border, caret and eye icon follow the theme colour,
     which Vuetify sets as `.v-application .primary--text` after this sheet,
     so this needs the extra class to win. */
  .direct-login .v-input.primary--text {
    color: var(--brand-teal) !important;
    caret-color: var(--brand-teal) !important;
  }
  @media (min-width: 810px) {
    .direct-login .login-background-img {
      background-image: url('/static/brand/login-illustration-desktop.jpg');
    }
  }
  </style>
  